import { Fragment, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Dropdown, Option, Tooltip, Avatar } from "@fluentui/react-components";
import { FluentBadge } from "../../../components/FluentUI/Fluent-Badge";
import { FluentButton } from "../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../assets/fluent-ui-icon";
import { ExcelExportColumn, toDataURL } from "@progress/kendo-react-excel-export";
import dayjs from "../../../util/dayjs-config";
import EmptyState from "../../../assets/img/Errors/emptyDataClipboard.svg";
import EmptyStateNoDealsOnFilter from "../../../assets/img/Errors/NoDealsOnFilter.svg";
import { orderBy, filterBy } from "@progress/kendo-data-query";
import PropTypes from "prop-types";
import { removeDuplicateHeaderRows } from "../dashboard-util/dashboard-telerik-helper/dashboard-telerik-helper";

export const renderWhenData = (dataLength, renderFunction) => {
  return dataLength === 0 ? () => null : renderFunction;
};

export const renderCellContent = (dataLength, emptyStateContent, filledContent) => {
  return dataLength === 0 ? emptyStateContent : filledContent;
};

export const getCategoryColor = (category, categoryOptions) => {
  const index = categoryOptions?.indexOf(category);
  const classnames = ["category-badge-purple", "category-badge-pink", "brand", "success", "severe", "category-badge-yellow"];
  return classnames[index % classnames.length] || "";
}


export const getAccordionMemberRowRender = (filteredData, groupState, toggleGroup, colspan, color = "informative") => {
  return (trElement, props) => {
    if (props.dataItem?.isEmptyRow ?? false) return trElement;

    const groupName = props.dataItem.GroupName;
    const isFirstInGroup =
      props.dataIndex ===
      filteredData.findIndex((item) => item.GroupName === groupName);
    const isVisible = groupState[groupName];

    if (!isFirstInGroup && !isVisible) return null;
    if (!isFirstInGroup) return isVisible ? trElement : null;

    const activeCount = filteredData.filter(
      (item) => item.GroupName === groupName
    ).length;

    return (
      <Fragment key={`group-${groupName}-${props.dataIndex}`}>
        <tr
          className="custom-group-header"
          style={{ backgroundColor: "#fff", height: "48px", borderBottom: "1px solid #edebe9", cursor: "pointer", lineHeight: "140%" }}
          onClick={() => toggleGroup(groupName)}
        >
          <td colSpan={colspan} style={{ padding: "0 16px", verticalAlign: "middle", borderBottom: "1px solid #edebe9", borderTop: "1px solid #edebe9" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <FluentButton
                className="accordion-toggle-button"
                disabled={false}
                icon={
                  <FluentUiIcon
                    name={isVisible ? "ChevronUpRegular" : "ChevronDownRegular"}
                    size={14}
                    disabled={false}
                  />
                }
                appearance="transparent"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleGroup(groupName);
                }}
              />
              <span style={{ fontWeight: "600", fontSize: "14px", marginLeft: "-10px" }}>
                {groupName ? groupName + "s" : ""}
              </span>
              <FluentBadge
                appearance="tint"
                size="large"
                color={color}
                text={`${activeCount} Banker${activeCount > 1 ? "s" : ""}`}
              />
            </div>
          </td>
        </tr>
        {isVisible && trElement}
      </Fragment>
    );
  };
};

export const getAccordionRowRender = (filteredData, groupState, toggleGroup, colspan, filters, categoryOptions, emptyCategories, groupNameLabel = "GroupName", BadgeLabel = "Deal") => {
  return (trElement, props) => {
    if (props.dataItem.isEmptyRow) return trElement;

    const groupName = props.dataItem.GroupName;
    const isFirstInGroup =
      filteredData.findIndex((item) => item.GroupName === groupName) ===
      filteredData.indexOf(props.dataItem);
    const isVisible = groupState[groupName] ?? true;
    const isLastRow = props.absoluteRowIndex === filteredData.length - 1 && filters == null;
    if (!isFirstInGroup && !isVisible && !isLastRow) return null;
    if (!isFirstInGroup && !isLastRow) return isVisible ? trElement : null;

    const activeCount = filteredData.filter(
      (item) => item.GroupName === groupName
    ).length;

    const emptyCategoriesToRender = isLastRow
      ? emptyCategories
      : [];

    return (
      <Fragment key={`group-${groupName}-${props.dataIndex}`}>
        {(!isLastRow || isFirstInGroup) && <tr
          className="custom-group-header"
          style={{ backgroundColor: "#fff", height: "48px", borderBottom: "1px solid #edebe9", cursor: "pointer", lineHeight: "140%" }}
          onClick={() => toggleGroup(groupName)}
        >
          <td colSpan={colspan} style={{ padding: "0 16px", verticalAlign: "middle", borderBottom: "1px solid #edebe9", borderTop: "1px solid #edebe9" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <FluentButton
                className="accordion-toggle-button"
                disabled={false}
                icon={
                  <FluentUiIcon
                    name={isVisible ? "ChevronUpRegular" : "ChevronDownRegular"}
                    size={14}
                    disabled={false}
                  />
                }
                appearance="transparent"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleGroup(groupName);
                }}
              />
              <span style={{ fontWeight: "600", fontSize: "16px", marginLeft: "-10px" }}>
                {groupName}
              </span>

              <FluentBadge
                appearance="tint"
                size="large"
                className={getCategoryColor(groupName, categoryOptions)}
                color={getCategoryColor(groupName, categoryOptions)}
                text={`${activeCount} ${BadgeLabel}${activeCount > 1 ? "s" : ""}`}
              />
            </div>
          </td>
        </tr>}
        {isVisible && trElement}
        {emptyCategoriesToRender.map(emptyCategory => (
          <tr
            key={`empty-category-${emptyCategory}`}
            className="custom-group-header"
            style={{ backgroundColor: "#fff", height: "48px", borderBottom: "1px solid #edebe9", cursor: "pointer", lineHeight: "140%", opacity: "0.7" }}
          >
            <td colSpan={colspan} style={{ padding: "0 16px", verticalAlign: "middle", borderBottom: "1px solid #edebe9", borderTop: "1px solid #edebe9" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <FluentButton
                  className="accordion-toggle-button"
                  disabled={false}
                  icon={
                    <FluentUiIcon
                      name={"ChevronDownRegular"}
                      size={14}
                      disabled={false}
                    />
                  }
                  appearance="transparent"

                />
                <span style={{ fontWeight: "600", fontSize: "16px", marginLeft: "-10px", color: "#6c757d" }}>
                  {emptyCategory}
                </span>

                <FluentBadge
                  appearance="tint"
                  size="large"
                  className={getCategoryColor(emptyCategory, categoryOptions)}
                  color={getCategoryColor(emptyCategory, categoryOptions)}
                  text={`0 Deals`}
                />
              </div>
            </td>
          </tr>
        ))}
      </Fragment>
    );
  };
};

export const applySearchFilter = (searchValue, detailState, onDetailStateChange, setGroupState) => {
  const trimmed = searchValue.trim();

  if (!trimmed) {
    onDetailStateChange({
      ...detailState,
      filter: null,
      skip: 0,
    });

    // setGroupState(DEFAULT_GROUPS);
    return;
  }

  const searchFilters = [
    { field: "DealName", operator: "contains", value: trimmed },
    { field: "ProcessType", operator: "contains", value: trimmed },
    { field: "Industry", operator: "contains", value: trimmed },
    { field: "Deliverable", operator: "contains", value: trimmed },
    { field: "TimeCommitment", operator: "contains", value: trimmed },
    { field: "ClientName", operator: "contains", value: trimmed },
  ];

  onDetailStateChange({
    ...detailState,
    filter: {
      logic: "or",
      filters: searchFilters,
    },
    skip: 0,
  });
};

export const applySearchFilterMembers = (searchValue, detailState, onDetailStateChange, setGroupState) => {
  const trimmed = searchValue.trim();

  if (!trimmed) {
    onDetailStateChange({
      ...detailState,
      filter: null,
      skip: 0,
    });

    // setGroupState(DEFAULT_GROUPS);
    return;
  }

  const searchFilters = [
    { field: "Banker", operator: "contains", value: trimmed },
    { field: "OverallCapacity", operator: "contains", value: trimmed },
    { field: "Total", operator: "contains", value: trimmed },
  ];

  onDetailStateChange({
    ...detailState,
    filter: {
      logic: "or",
      filters: searchFilters,
    },
    skip: 0,
  });
};

const toDateSafe = (v) => (v instanceof Date ? v : v ? new Date(v) : null);
const toLocalMidnight = (v) => {
  const d = toDateSafe(v);
  return d && !isNaN(d.getTime()) ? new Date(d.getFullYear(), d.getMonth(), d.getDate()) : null;
};

const rehydrateLastUpdatedFilters = (node) => {
  if (!node) return node;
  if (Array.isArray(node.filters)) {
    return { ...node, filters: node.filters.map(rehydrateLastUpdatedFilters) };
  }
  if (node.field === "LastUpdated") {
    return { ...node, value: toLocalMidnight(node.value) };
  }
  return node;
};
export const getFlattenedData = (data) => {
  return data?.map((item) => {
    const stafferNames = item.Staffers?.map((m) => m.User?.Name).filter(Boolean);
    const dealTeamNames = item?.DealTeam?.map((m) => m.User?.Name).filter(Boolean);
    return {
      ...item,
      StafferNamesArray: stafferNames || [],
      StafferNamesString: stafferNames?.join(", ") || "",
      DealTeamNamesArray: dealTeamNames || [],
      DealTeamNamesString: dealTeamNames?.join(", ") || "",
    };
  });
};

export const getBankerInfoFlattenedData = (data) => {
  return data?.map((item) => {
    const stafferNames = item.Staffers?.map((m) => m.User?.Name).filter(Boolean);
    const bankerAnalystNames = item.BankerInfo?.filter((m) => m.GroupName == "Analyst").map((m) => m.Banker).filter(Boolean);
    const bankerAssociatesVPNames = item.BankerInfo?.filter((m) => m.GroupName == "Associates/VP").map((m) => m.Banker).filter(Boolean);
    return {
      ...item,
      StafferNamesArray: stafferNames || [],
      StafferNamesString: stafferNames?.join(", ") || "",
      BankerAnalyst: bankerAnalystNames?.join(", ") || "",
      BankerAssociatesVP: bankerAssociatesVPNames?.join(", ") || "",
    };
  });
};

export const getFilteredSortedData = (flattenedData, filter, sort, priorityOrder) => {
  let temp = flattenedData.map((r) => ({ ...r, LastUpdated: toLocalMidnight(r.LastUpdated) }));

  const staffersFilters = [];
  const dealTeamFilters = [];
  (filter?.filters || []).forEach((f) => {
    if (f.field === "Staffers") {
      staffersFilters.push((f.value ?? "").toLowerCase());
    }
    else if (f.field === "DealTeam") {
      dealTeamFilters.push((f.value ?? "").toLowerCase());
    }
    else if (Array.isArray(f.filters)) {
      f.filters.forEach((inner) => {
        if (inner.field === "Staffers") {
          staffersFilters.push((inner.value ?? "").toLowerCase());
        }
        else if (inner.field === "DealTeam") {
          dealTeamFilters.push((inner.value ?? "").toLowerCase());
        }
      });
    }
  });

  if (staffersFilters.length) {
    temp = temp.filter((item) =>
      item.StafferNamesArray?.some((name) => staffersFilters.includes((name || "").toLowerCase()))
    );
  }

  if (dealTeamFilters.length) {
    temp = temp.filter((item) =>
      item.DealTeamNamesArray?.some((name) => dealTeamFilters.includes((name || "").toLowerCase()))
    );
  }

  const kendoCompatibleFilters =
    filter?.filters?.filter(
      (f) => f.field !== "Staffers" && f.field !== "DealTeam" && !f.filters?.some((inner) => inner.field === "Staffers" || inner.field === "DealTeam")
    ) ?? [];

  const processedFilter = rehydrateLastUpdatedFilters({ ...filter, filters: kendoCompatibleFilters });

  if (processedFilter?.filters?.length) {
    temp = filterBy(temp, processedFilter);
  }

  const sortedData = sort?.length
    ? sort[0].field === "Staffers"
      ? [...temp].sort((a, b) => {
        const countA = a.StafferNamesArray?.length || 0;
        const countB = b.StafferNamesArray?.length || 0;
        return sort[0].dir === "asc" ? countA - countB : countB - countA;
      })
      : sort[0].field === "DealTeam"
        ? [...temp].sort((a, b) => {
          const countA = a.DealTeamNamesArray?.length || 0;
          const countB = b.DealTeamNamesArray?.length || 0;
          return sort[0].dir === "asc" ? countA - countB : countB - countA;
        })
        : orderBy(temp, sort)
    : temp;


  const prioritized = (Array.isArray(sortedData) ? sortedData : []).sort((a, b) => {
    const aName = a.GroupName || "";
    const bName = b.GroupName || "";
    if (aName === bName) return 0;

    // Guard priorityOrder; treat missing as empty array
    const priorities = Array.isArray(priorityOrder) ? priorityOrder : [];
    const aIdx = priorities.indexOf(aName);
    const bIdx = priorities.indexOf(bName);
    const aIn = aIdx !== -1;
    const bIn = bIdx !== -1;

    if (aIn && !bIn) return -1;
    if (bIn && !aIn) return 1;
    if (aIn && bIn) return aIdx - bIdx;

    // Fallback alphabetical if neither is prioritized
    return aName.localeCompare(bName);
  });

  return prioritized;
};

export const useMemberGroupToggle = (initialState = { Analyst: true, 'Associates/VP': true }) => {
  const [groupState, setGroupState] = useState(initialState);

  const toggleGroup = useCallback((groupName) => {
    setGroupState((prev) => ({
      ...prev,
      [groupName]: !prev[groupName],
    }));
  }, []);

  return { groupState, toggleGroup, setGroupState };
};

export const useGroupToggle2 = (initialState = { 'Left Execution - Existing': true }) => {
  const [groupState, setGroupState] = useState(initialState);

  const toggleGroup = useCallback((groupName) => {
    setGroupState((prev) => ({
      ...prev,
      [groupName]: prev[groupName] !== undefined ? !prev[groupName] : false,
    }));
  }, []);

  return { groupState, toggleGroup, setGroupState };
};



// Export Data Helpers
//Jr banker
export const getMyDealSummaryColumns = (CategoryOptions = []) => (
  <>
    <ExcelExportColumn field="Banker" title="Banker" />
    <ExcelExportColumn field="OverallCapacity" title="Overall Capacity" />
    {CategoryOptions.map((item) => (
      <ExcelExportColumn key={item} field={item} title={`# of ${item}`} />
    ))}
    <ExcelExportColumn field="Total" title="Total" />
    <ExcelExportColumn field="LastUpdated" title="Last Updated" cellOptions={{ format: "mm/dd/yyyy" }} />
  </>
);



export const getMyDealDetailColumns = () => {
  return (
    <>
      <ExcelExportColumn field="DealId" title="#" />
      <ExcelExportColumn field="GroupName" title="Category" />
      <ExcelExportColumn field="DealName" title="Deal Name" />
      <ExcelExportColumn field="ProcessType" title="Process Type" />
      <ExcelExportColumn field="Industry" title="Industry" />
      <ExcelExportColumn field="Deliverable" title="Deliverable" />
      <ExcelExportColumn field="TimeCommitment" title="Deal Time Commitment" />
      <ExcelExportColumn field="MD_D" title="MD / D" />
      <ExcelExportColumn field="D_VP" title="D / VP" />
      <ExcelExportColumn field="StafferNamesString" title="Staffers" />
      <ExcelExportColumn field="DealTeamNamesString" title="Deal Team" />
    </>
  );
};

export const getMyDealModalDetailColumns = () => {
  return (
    <>
      <ExcelExportColumn field="DealId" title="#" />
      <ExcelExportColumn field="GroupName" title="Category" />
      <ExcelExportColumn field="DealName" title="Deal Name" />
      <ExcelExportColumn field="ProcessType" title="Process Type" />
      <ExcelExportColumn field="Industry" title="Industry" />
      <ExcelExportColumn field="Deliverable" title="Deliverable" />
      <ExcelExportColumn field="TimeCommitment" title="Deal Time Commitment" />
      <ExcelExportColumn field="MD_D" title="MD / D" />
      <ExcelExportColumn field="D_VP" title="D / VP" />
      <ExcelExportColumn field="BankerAnalyst" title="Analyst" />
      <ExcelExportColumn field="BankerAssociatesVP" title="Associates/VP" />
    </>
  );
};

export const mapMyDealSummaryExportData = (summaryItem) => {
  if (!summaryItem) return [];
  const row = {
    Banker: summaryItem.Banker || "",
    OverallCapacity: summaryItem.OverallCapacity || "",
    Total: summaryItem.Total ?? 0,
    LastUpdated: summaryItem.LastUpdated || "",
  };
  (summaryItem.NumberOfDeals || []).forEach((item) => {
    row[item.Key] = item.Value ?? 0;
  });
  return [row];
};

export const mapDealTrackerSummaryExportData = (summaryItem) => {
  if (!summaryItem) return [];
  const row = {
    Total: summaryItem.Total ?? 0,
  };
  (summaryItem.NumberOfDeals || []).forEach((item) => {
    row[item.Key] = item.Value ?? 0;
  });
  return [row];
};

export const getDealsData = (flattenedData) => {
  return (flattenedData || []).flatMap((item) =>
    item?.Deals?.map((deal) => {
      const stafferNames = deal?.Staffers?.map((m) => m.User?.Name).filter(Boolean);
      const dealTeamNames = deal?.DealTeam?.map((m) => m.User?.Name).filter(Boolean);
      return {
        Banker: item.Banker || "",
        DealId: deal.DealId,
        GroupName: deal.GroupName,
        DealName: deal.DealName,
        ProcessType: deal.ProcessType,
        Industry: deal.Industry,
        Deliverable: deal.Deliverable,
        TimeCommitment: deal.TimeCommitment,
        MD_D: deal.MD_D,
        D_VP: deal.D_VP,
        Staffers: stafferNames?.join(", ") || "",
        DealTeam: dealTeamNames?.join(", ") || "",
      };
    }
    )
  );
};
//Others

export const getMemberSummaryColumns = () => (
  <>
    <ExcelExportColumn field="Banker" title="Analyst/Associate" />
    <ExcelExportColumn field="GroupName" title="Role" />
    <ExcelExportColumn field="OverallCapacity" title="Overall Capacity" />
    <ExcelExportColumn field="NumberOfDeals" title="# of Deals" />
    <ExcelExportColumn field="LastUpdated" title="Last Updated" cellOptions={{ format: "mm/dd/yyyy" }} />
  </>
);

export const getDealTrackerModalColumns = () => {
  return (
    <>
      <ExcelExportColumn field="Banker" title="Banker" />
      <ExcelExportColumn field="DealId" title="#" />
      <ExcelExportColumn field="GroupName" title="Category" />
      <ExcelExportColumn field="DealName" title="Deal Name" />
      <ExcelExportColumn field="ProcessType" title="Process Type" />
      <ExcelExportColumn field="Industry" title="Industry" />
      <ExcelExportColumn field="Deliverable" title="Deliverable" />
      <ExcelExportColumn field="TimeCommitment" title="Deal Time Commitment" />
      <ExcelExportColumn field="MD_D" title="MD / D" />
      <ExcelExportColumn field="D_VP" title="D / VP" />
      <ExcelExportColumn field="Staffers" title="Staffer(s)" />
      <ExcelExportColumn field="DealTeam" title="Deal Team" />
    </>
  );
};

export const getDealTrackerSummaryColumns = (CategoryOptions = []) => (
  <>
    {CategoryOptions.map((item) => (
      <ExcelExportColumn key={item} field={item} title={`# of ${item}`} />
    ))}
    <ExcelExportColumn field="Total" title="Total" />
  </>
);

export const getMembersTimeLogModalDetailColumns = () => (
  <>
    <ExcelExportColumn field="DealId" title="#" />
    <ExcelExportColumn field="DealName" title="Deal Name" />
    <ExcelExportColumn field="GroupName" title="Deal Status" />
    <ExcelExportColumn field="ProcessType" title="Process Type" />
    <ExcelExportColumn field="Industry" title="Industry" />
    <ExcelExportColumn field="Deliverable" title="Deliverable" />
    <ExcelExportColumn field="TimeCommitment" title="Deal Time Commitment" />
    <ExcelExportColumn field="LastUpdated" title="Last Updated" cellOptions={{ format: "mm/dd/yyyy" }} />
  </>
);

export const getMembersTimeLogColumns = (CategoryOptions = []) => (
  <>
    <ExcelExportColumn field="Banker" title="Analyst/Associate" />
    <ExcelExportColumn field="GroupName" title="Role" />
    <ExcelExportColumn field="OverallCapacity" title="Overall Capacity" />
    {CategoryOptions.map((item) => (
      <ExcelExportColumn key={item} field={item} title={`# of ${item}`} />
    ))}
    <ExcelExportColumn field="LastUpdated" title="Last Updated" cellOptions={{ format: "mm/dd/yyyy" }} />
  </>
);

export const sortMembersByRoleAndCapacity = (members) => {
  if (!Array.isArray(members)) {
    return [];
  }

  const ROLE_ORDER = ["Associate", "Analyst"];
  const CAPACITY_ORDER = ["High", "Medium", "Low"];

  return [...members].sort((a, b) => {
    const roleOrderA = ROLE_ORDER.indexOf(a.GroupName) !== -1 ? ROLE_ORDER.indexOf(a.GroupName) : 999;
    const roleOrderB = ROLE_ORDER.indexOf(b.GroupName) !== -1 ? ROLE_ORDER.indexOf(b.GroupName) : 999;

    if (roleOrderA !== roleOrderB) {
      return roleOrderA - roleOrderB;
    }

    const capacityOrderA = CAPACITY_ORDER.indexOf(a.OverallCapacity) !== -1 ? CAPACITY_ORDER.indexOf(a.OverallCapacity) : 999;
    const capacityOrderB = CAPACITY_ORDER.indexOf(b.OverallCapacity) !== -1 ? CAPACITY_ORDER.indexOf(b.OverallCapacity) : 999;

    return capacityOrderA - capacityOrderB;
  });
};

export const getLevfinTimeLogFileName = (name) => {
  const timestamp = dayjs().format("YYYY-MM-DD HH-mm-ss");
  return `${name} ${timestamp}.xlsx`;
};

export const handleExport = async ({ summaryRef, detailRef, name }) => {
  if (!summaryRef.current || !detailRef.current) return;

  const fileName = getLevfinTimeLogFileName(name);

  const summaryWorkbook = summaryRef.current.workbookOptions();
  if (summaryWorkbook?.sheets?.length > 0) {
    summaryWorkbook.sheets[0].title = "Summary";
    removeDuplicateHeaderRows(summaryWorkbook.sheets[0]);
  }

  const detailWorkbook = detailRef.current.workbookOptions();
  if (detailWorkbook?.sheets?.length > 0) {
    detailWorkbook.sheets[0].title = "Deals";
    removeDuplicateHeaderRows(detailWorkbook.sheets[0]);
  }

  const workbook = {
    sheets: [
      ...(summaryWorkbook?.sheets || []),
      ...(detailWorkbook?.sheets || []),
    ],
  };

  const dataUrl = await toDataURL(workbook);

  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const handleMyDealExport = async ({ summaryRef, detailRef, summaryData, detailData, categoryOptions = [] }) => {
  if (!detailRef.current) return;

  const fileName = getLevfinTimeLogFileName("Banker Time Log");

  // Build summary sheet manually to handle dynamic columns
  const summaryColumns = [
    { field: "Banker", title: "Banker" },
    { field: "OverallCapacity", title: "Overall Capacity" },
    ...categoryOptions.map((cat) => ({ field: cat, title: `# of ${cat}` })),
    { field: "Total", title: "Total" },
    { field: "LastUpdated", title: "Last Updated" },
  ];

  const summaryHeaderRow = {
    type: "header",
    cells: summaryColumns.map((col) => ({ value: col.title, background: "#7a7a7a", color: "#fff", bold: true })),
  };

  const summaryDataRows = (summaryData || []).map((item) => ({
    type: "data",
    cells: summaryColumns.map((col) => ({ value: item[col.field] ?? "" })),
  }));

  const summarySheet = {
    title: "Summary",
    rows: [summaryHeaderRow, ...summaryDataRows],
    columns: summaryColumns.map(() => ({ autoWidth: true })),
    frozenRows: 1,
  };

  // Detail sheet from ExcelExport component
  const detailWorkbook = detailRef.current.workbookOptions(detailData);
  if (detailWorkbook?.sheets?.length > 0) {
    detailWorkbook.sheets[0].title = "Deals";
    removeDuplicateHeaderRows(detailWorkbook.sheets[0]);
  }

  const workbook = {
    sheets: [
      summarySheet,
      ...(detailWorkbook?.sheets || []),
    ],
  };

  const dataUrl = await toDataURL(workbook);

  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const handleStafferTimeLogExport = async ({ mainRef, modalRef, mainData, modalData, categoryOptions = [], fileNameBase = "Analysts & Associates/VPs Log" }) => {
  if (!modalRef.current) return;

  const fileName = getLevfinTimeLogFileName(fileNameBase);
  console.log("Exporting with category options:", mainData, categoryOptions);
  // Build main sheet manually to handle dynamic columns
  const mainColumns = [
    { field: "Banker", title: "Banker" },
    { field: "OverallCapacity", title: "Overall Capacity" },
    ...categoryOptions.map((cat) => ({ field: cat, title: `# of ${cat}` })),
    { field: "Total", title: "Total" },
    { field: "LastUpdated", title: "Last Updated" },
  ];

  const mainHeaderRow = {
    type: "header",
    cells: mainColumns.map((col) => ({ value: col.title, background: "#7a7a7a", color: "#fff", bold: true })),
  };

  const mainDataRows = (mainData || []).map((item) => ({
    type: "data",
    cells: mainColumns.map((col) => ({ value: item[col.field] ?? "" })),
  }));

  const mainSheet = {
    title: "Bankers",
    rows: [mainHeaderRow, ...mainDataRows],
    columns: mainColumns.map(() => ({ autoWidth: true })),
    frozenRows: 1,
  };

  // Detail sheet from ExcelExport component
  const detailWorkbook = modalRef.current.workbookOptions(modalData);
  if (detailWorkbook?.sheets?.length > 0) {
    detailWorkbook.sheets[0].title = "Deals";
    removeDuplicateHeaderRows(detailWorkbook.sheets[0]);
  }

  const workbook = {
    sheets: [
      mainSheet,
      ...(detailWorkbook?.sheets || []),
    ],
  };

  const dataUrl = await toDataURL(workbook);

  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


export const handleDealTrackerExport = async ({ summaryRef, detailRef, summaryData, detailData, categoryOptions = [] }) => {
  if (!detailRef.current) return;

  const fileName = getLevfinTimeLogFileName("Deal Tracker Export");

  // Build summary sheet manually to handle dynamic columns
  const summaryColumns = [
    ...categoryOptions.map((cat) => ({ field: cat, title: `# of ${cat}` })),
    { field: "Total", title: "Total" },
  ];

  const summaryHeaderRow = {
    type: "header",
    cells: summaryColumns.map((col) => ({ value: col.title, background: "#7a7a7a", color: "#fff", bold: true })),
  };

  const summaryDataRows = (summaryData || []).map((item) => ({
    type: "data",
    cells: summaryColumns.map((col) => ({ value: item[col.field] ?? "" })),
  }));

  const summarySheet = {
    title: "Summary",
    rows: [summaryHeaderRow, ...summaryDataRows],
    columns: summaryColumns.map(() => ({ autoWidth: true })),
    frozenRows: 1,
  };

  // Detail sheet from ExcelExport component
  const detailWorkbook = detailRef.current.workbookOptions(detailData);
  if (detailWorkbook?.sheets?.length > 0) {
    detailWorkbook.sheets[0].title = "Deals";
    removeDuplicateHeaderRows(detailWorkbook.sheets[0]);
  }

  const workbook = {
    sheets: [
      summarySheet,
      ...(detailWorkbook?.sheets || []),
    ],
  };

  const dataUrl = await toDataURL(workbook);

  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const handleDealTrackerModalExport = async ({ detailRef }) => {
  if (!detailRef.current) return;

  const fileName = getLevfinTimeLogFileName("Deal Tracker Modal Export");

  const detailWorkbook = detailRef.current.workbookOptions();
  if (detailWorkbook?.sheets?.length > 0) {
    detailWorkbook.sheets[0].title = "DealInfo";
    removeDuplicateHeaderRows(detailWorkbook.sheets[0]);
  }

  const workbook = {
    sheets: [
      ...(detailWorkbook?.sheets || []),
    ],
  };

  const dataUrl = await toDataURL(workbook);

  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Local Storage Helpers
export const getStorageKey = (key, userId) => `${key}_user_${userId}`;

export const getInitialDetailState = (userId, baseKey = "levfinBanker") => {
  if (!userId) return { sort: [], filter: null };

  try {
    const sortRaw = localStorage.getItem(getStorageKey(`${baseKey}Sort`, userId));
    const filterRaw = localStorage.getItem(getStorageKey(`${baseKey}Filter`, userId));
    const sort = sortRaw ? JSON.parse(sortRaw) : [];
    const filter = filterRaw ? JSON.parse(filterRaw) : null;
    return { sort, filter };
  } catch (e) {
    console.warn("Failed to parse localStorage", e);
    return { sort: [], filter: null };
  }
};

export const saveDetailStateToStorage = (userId, newState, searchValue, baseKey = "levfinBanker") => {
  if (!userId || searchValue?.trim()) return;
  localStorage.setItem(getStorageKey(`${baseKey}Sort`, userId), JSON.stringify(newState.sort));
  localStorage.setItem(getStorageKey(`${baseKey}Filter`, userId), JSON.stringify(newState.filter));
};

export const clearDetailStateFromStorage = (userId, baseKey = "levfinBanker") => {
  if (!userId) return;
  console.log("Removing keys:", getStorageKey(`${baseKey}Sort`, userId), getStorageKey(`${baseKey}Filter`, userId));
  localStorage.removeItem(getStorageKey(`${baseKey}Sort`, userId));
  localStorage.removeItem(getStorageKey(`${baseKey}Filter`, userId));
};

// Helper Components
export const ProjectIdCell = ({ dataItem, canEdit, categoryOptions, onClick, isVisible = false }) => (
  <td className="badge-edit-cell background-white k-table-td">
    <div className="badge-edit-content" style={{ pointerEvents: 'none' }}>
      <LevfinIdBadge text={`GIB-${dataItem.DealId}`} groupName={dataItem.GroupName} categoryOptions={categoryOptions} />
      {isVisible && dataItem && (
        <EditIconButton
          projectId={dataItem.DealId}
          projectName={dataItem.DealName}
          canEdit={canEdit}
        />
      )}
    </div>
  </td>
);

export const EditIconButton = ({ projectId, projectName, canEdit }) => {
  const [hovered, setHovered] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const history = useHistory();

  return (
    <div className={`edit-button-wrapper ${tooltipVisible ? "tooltip-open" : ""}`}>
      <Tooltip
        content={
          canEdit ? <span>
            Edit <span style={{ fontWeight: 500 }}>{projectName}</span> Deal
          </span> : <span>To make Edits, please join this Deal first. Reach out to another Staffer or a Deal Member to get added.</span>
        }
        relationship="label"
        positioning="above"
        onVisibleChange={(_, data) => setTooltipVisible(data.visible)}
      >
        <div
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={{ display: "inline-block" }}
        >
          <FluentButton
            icon={
              <FluentUiIcon
                name={hovered ? "EditFilled" : "EditRegular"}
                color={`${canEdit ? "#0F6CBD" : "#A0A0A0"}`}
                size={20}
              />
            }
            onClick={() => {
              if (canEdit) {
                history.push({
                  pathname: `/projects/edit/${projectId}`,
                  state: { fromDashboard: true },
                });
              }
            }}
            appearance="transparent"
            className="edit-hover-button"
          />
        </div>
      </Tooltip>
    </div>
  );
};

export const LevfinBankerEmptyState = ({ CanEdit = false, DealId }) => {
  const history = useHistory();

  return (
    <div className="empty-state-container">
      <img src={EmptyState} alt="No Data" />
      <p className="empty-state-header">
        No Analysts or Associates/VPs added to this Deal yet ⏳
      </p>
      <p className="empty-state-subtext">
        There are currently no Analysts or Associates/VPs assigned to this Deal.
      </p>
      <p className="empty-state-subtext">
        Add Deal Team Members to begin managing Staffing and Resource allocation for this Deal.
      </p>
      <FluentButton
        appearance="secondaryWithOutline"
        text={"Add Deal Team Members"}
        onClick={() =>
          history.push({
            pathname: `/projects/edit/${DealId}`,
            state: { fromDashboard: true },
          })
        }
        disabled={!CanEdit}
      />
    </div>
  );
};

export const LevfinNoDealEmptyState = () => {
  const history = useHistory();

  return (
    <div className="empty-state-container">
      <img src={EmptyState} alt="No Data" />
      <p className="empty-state-header">
        No Deals Assigned Yet — Let’s Fix That!
      </p>
      <p className="empty-state-subtext">
        Looks like this user hasn’t been assigned to any Leveraged Finance Deals on TRIYO yet.
      </p>
      <p className="empty-state-subtext">
        Create a new Deal and add them to begin managing Staffing and Resource allocation.
      </p>
      <FluentButton
        appearance="secondaryWithOutline"
        icon={<FluentUiIcon name={"FolderAddRegular"} color={"#0F6CBD"} size={20} />}
        text={"Create a new Deal"}
        onClick={() =>
          history.push({
            pathname: `/projects/create`,
            state: { fromDashboard: true },
          })
        }
      />
    </div>
  );
};

export const LevfinNoMembersEmptyState = () => {
  const history = useHistory();

  return (
    <div className="empty-state-container">
      <img src={EmptyState} alt="No Data" />
      <p className="empty-state-header">
        No Analysts or Associates/VPs onboarded yet ⛅️
      </p>
      <p className="empty-state-subtext">
        There are currently no Leveraged Finance Analysts or Associates/VPs onboarded to TRIYO. Once they are onboarded by RBC’s AACG team, they will appear here.
      </p>
      <p className="empty-state-subtext">
        Need help in the meantime? TRIYO’s Support Team is happy to assist.
      </p>
      <a href="mailto:support@triyo.com" style={{ textDecoration: 'none' }}>
        <FluentButton
          appearance="secondaryWithOutline"
          text={"Contact TRIYO Support"}
        />
      </a>
    </div>
  );
};

export const LevfinNoDealonDealsTrackerEmptyState = ({ canCreate }) => {
  const history = useHistory();

  return (
    <div className="empty-state-container">
      <img src={EmptyState} alt="No Data" />
      <p className="empty-state-header">
        No Deals on TRIYO yet — Let’s get started! 🚀
      </p>
      <p className="empty-state-subtext">
        Looks like the Leveraged Finance GIB Group hasn’t created any Deals on TRIYO yet.
      </p>
      <p className="empty-state-subtext">
        Create a new Deal on TRIYO to enable streamlined Staffing and Resource Management.
      </p>
      <FluentButton
        appearance="secondaryWithOutline"
        icon={<FluentUiIcon name={"FolderAddRegular"} color={canCreate ? "#0F6CBD" : "#A6A6A6"} size={20} />}
        text={"Create a new Deal"}
        disabled={!canCreate}
        onClick={() =>
          history.push({
            pathname: `/projects/create`,
            state: { fromDashboard: true },
          })
        }
      />
    </div>
  );
};

export const LevfinBankerNoDealOnSearchState = ({ resetDataState, refineSearch }) => {
  return (
    <div className="empty-state-container">
      <img src={EmptyStateNoDealsOnFilter} alt="No Data" />
      <p className="empty-state-header">
        Hmm, nothing matched — but there are more places to look! 🕵️‍🫣
      </p>
      <p className="empty-state-subtext">
        No Deals match your search criteria.<br /><br />
        You can{" "}
        <button
          type="button"
          onClick={resetDataState}
          className="create-deal-link"
        >
          reset your search
        </button>{" "} OR try{" "}
        <button
          className="create-deal-link"
          onClick={refineSearch}
        >
          refining your keywords
        </button>{"."}
      </p>
    </div>
  );
};

export const LevfinBankerNoDealOnFilterState = ({ resetDataState }) => {
  return (
    <div className="empty-state-container">
      <img src={EmptyStateNoDealsOnFilter} alt="No Data" />
      <p className="empty-state-header">
        No results found with the current filters!{" "}
        <FluentUiIcon name="SearchRegular" color="#424242" size={20} />
      </p>
      <p className="empty-state-subtext">
        Try{" "}
        <button
          type="button"
          onClick={resetDataState}
          className="create-deal-link"
        >
          adjusting the filter options
        </button>{" "}
        to refine your results.
      </p>
    </div>
  );
};

export const LevfinIdBadge = ({ text, groupName, categoryOptions }) => {
  return (
    <FluentBadge
      shape="rounded"
      appearance="tint"
      size="medium"
      className={getCategoryColor(groupName, categoryOptions)}
      color={getCategoryColor(groupName, categoryOptions)}
      text={text}
    />
  );
};

export const LevfinCapacity = ({ capacity }) => {
  return (
    <div className={`${capacity} levfin-capacity`} style={{ pointerEvents: 'none' }}>
      <FluentBadge
        shape="rounded"
        appearance="tint"
        size="extra-large"
        text={capacity?.charAt(0)?.toUpperCase()}
      ></FluentBadge>
    </div>
  );
};

export const OverallCapacityCellNonEditable = ({ value }) => {
  const normalized = (value || "");
  const isValid = ["Low", "Medium", "High"].includes(normalized);
  const colorMap = { Low: "#D83B01", Medium: "#0F6CBD", High: "#107C10" };
  const iconMap = {
    Low: "Fire20Filled",
    Medium: "TextAsterisk20Filled",
    High: "BowlChopsticks20Filled",
  };
  return (
    <div className={`oc-wrap ${isValid ? `oc-${normalized}` : ""}`}>
      {isValid && (
        <span className="oc-trigger-label-non-editable" aria-hidden="true">
          <FluentUiIcon
            name={iconMap[normalized]}
            size={16}
            color={colorMap[normalized]}
          />
          {normalized}
        </span>
      )}
    </div>
  );
};

export const OverallCapacityCell = ({ value, taskExists, onChange, isBanker, canEdit }) => {
  const disabled = !taskExists || !canEdit;
  const normalized = (value || "");
  const isValid = ["Low", "Medium", "High"].includes(normalized);
  const selectedOptions = isValid ? [normalized] : [];

  const labelMap = { Low: "Low", Medium: "Medium", High: "High" };
  const colorMap = { Low: "#D83B01", Medium: "#0F6CBD", High: "#107C10" };
  const iconMap = {
    Low: "Fire20Filled",
    Medium: "TextAsterisk20Filled",
    High: "BowlChopsticks20Filled",
  };
  let text = "";
  if (isBanker) {
    text = "Available once the Overall Capacity Tracking project is launched and assigned to you — please contact your Staffer for access.";
  }
  else {
    if (taskExists && !canEdit) {
      text = "You don't have permission to edit this Banker’s Overall Capacity.";
    }
    else {
      text = "Available once the Overall Capacity Tracking project is launched and this Banker is assigned.";
    }
  }
  return (
    <Tooltip
      content={text}
      relationship="label"
      withArrow
      positioning="above"
      visible={disabled ? undefined : false}
    >
      <div
        className={`oc-wrap ${isValid ? `oc-${normalized}` : ""}`}
        style={{ position: "relative", minWidth: 180, width: "100%" }}
      >
        {isValid && (
          <span className="oc-trigger-icon" aria-hidden="true">
            <FluentUiIcon
              name={iconMap[normalized]}
              size={16}
              color={colorMap[normalized]}
            />
          </span>
        )}

        {isValid && (
          <span className="oc-trigger-label" aria-hidden="true">
            {labelMap[normalized]}
          </span>
        )}

        <Dropdown
          aria-label="Overall Capacity"
          disabled={disabled}
          placeholder={taskExists && !isValid ? "Please select" : undefined}
          selectedOptions={selectedOptions}
          appearance="outline"
          onOptionSelect={(_, data) => {
            if (!disabled && data.optionValue) onChange?.(String(data.optionValue));
          }}
        >
          <Option value="Low" text={labelMap.Low}>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <FluentUiIcon name={iconMap.Low} size={16} color={colorMap.Low} />
              {labelMap.Low}
            </span>
          </Option>
          <Option value="Medium" text={labelMap.Medium}>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <FluentUiIcon name={iconMap.Medium} size={16} color={colorMap.Medium} />
              {labelMap.Medium}
            </span>
          </Option>
          <Option value="High" text={labelMap.High}>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <FluentUiIcon name={iconMap.High} size={16} color={colorMap.High} />
              {labelMap.High}
            </span>
          </Option>
        </Dropdown>
      </div>
    </Tooltip>
  );
};

export const renderAvatarWithName = (name, color) => {
  if (!name || name === "—") return "—";
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Avatar
        name={name}
        color={color}
        size={24}
      />
      <span>{name}</span>
    </div>
  );
};

LevfinIdBadge.propTypes = {
  text: PropTypes.string.isRequired,
  groupName: PropTypes.string.isRequired,
};

ProjectIdCell.propTypes = {
  dataItem: PropTypes.shape({
    ProjectId: PropTypes.number.isRequired,
    ProjectIdString: PropTypes.string.isRequired,
    ProjectName: PropTypes.string.isRequired,
  }).isRequired,
  canEdit: PropTypes.bool.isRequired,
  isNewDeal: PropTypes.bool.isRequired,
};

EditIconButton.propTypes = {
  projectId: PropTypes.number.isRequired,
  projectName: PropTypes.string.isRequired,
};

LevfinBankerNoDealOnSearchState.propTypes = {
  resetDataState: PropTypes.func.isRequired,
  refineSearch: PropTypes.func.isRequired,
};

LevfinBankerEmptyState.propTypes = {
  canCreate: PropTypes.bool.isRequired,
};

OverallCapacityCell.propTypes = {
  value: PropTypes.string,
  taskExists: PropTypes.bool,
  onChange: PropTypes.func,
};

OverallCapacityCellNonEditable.propTypes = {
  value: PropTypes.string
};

LevfinCapacity.propTypes = {
  capacity: PropTypes.string,
};

LevfinNoDealonDealsTrackerEmptyState.propTypes = {
  canCreate: PropTypes.bool,
};